import { FiSearch } from 'react-icons/fi';
import { ImSpinner8 } from 'react-icons/im';
import { DealerForSearchType } from '../../types';
import { GeoCoordinates } from '../../types/geoSearchResponse';
import ResizablePanel from '../form/containers/ResizablePanel';
import ListView from './ListView';

interface DealerResultsProps {
  loading: boolean;
  filteredDealers: DealerForSearchType[];
  geoCoordinates: GeoCoordinates | null;
  searchText: string;
  matchBrandSearch: (dealer: DealerForSearchType) => boolean;
  matchServiceSearch: (dealer: DealerForSearchType) => boolean;
  matchButtonGroupFilter: (dealer: DealerForSearchType) => boolean;
  sortByGeoLocation: (a: DealerForSearchType, b: DealerForSearchType) => number;
  dealers: DealerForSearchType[];
}

const DealerResults = ({
  loading,
  filteredDealers,
  geoCoordinates,
  searchText,
  matchBrandSearch,
  matchServiceSearch,
  matchButtonGroupFilter,
  sortByGeoLocation,
  dealers,
}: DealerResultsProps) => {
  // Render loading state
  if (loading) {
    return (
      <ResizablePanel>
        <div className="flex items-center justify-center py-12">
          <ImSpinner8 className="text-4xl animate-spin text-[#8e94a0]" />
        </div>
      </ResizablePanel>
    );
  }

  // Render results if we have any
  if (filteredDealers.length) {
    return (
      <ResizablePanel>
        <ListView dealers={filteredDealers} />
      </ResizablePanel>
    );
  }

  // Get appropriate titles based on search context
  const noResultsTitle = geoCoordinates
    ? 'Ingen forhandlere innen 50 km'
    : `Ingen treff på "${searchText}"`;

  const noResultsMessage = geoCoordinates
    ? `Vi fant ingen forhandlere nær "${searchText}".`
    : 'Prøv et annet poststed eller postnummer.';

  // Render no results state
  return (
    <ResizablePanel>
      <div className="text-center py-6 mb-8 border-b border-gray-200">
        <div className="mb-4 text-tertiary">
          <FiSearch className="inline-block text-4xl" />
        </div>
        <h3 className="text-2xl font-semibold mb-2">{noResultsTitle}</h3>
        <p className="mb-2">{noResultsMessage}</p>
      </div>

      {/* Show closest dealers anyway */}
      {geoCoordinates && dealers.length > 0 && (
        <div>
          <h4 className="text-xl font-medium mb-4">Nærmeste forhandlere:</h4>
          <ListView
            dealers={dealers
              .filter(matchBrandSearch)
              .filter(matchServiceSearch)
              .filter(matchButtonGroupFilter)
              .sort(sortByGeoLocation)
              .slice(0, 3)}
          />
        </div>
      )}
    </ResizablePanel>
  );
};

export default DealerResults;
